// The brand palette: the only place raw colors live. Components never read it
// directly; they read the light and dark tokens built from it in `tokens.ts`.
export const palette = {
  white: '#ffffff',
  black: '#000000',
  dark: '#0d1a2f',
  // The dark ink of the logo
  brandInk: '#1b335c',

  neutral100: '#f2f3f8',
  neutral200: '#d8dce9',
  neutral300: '#bdc4db',
  neutral400: '#a3adcc',
  neutral500: '#6e7daf',
  neutral600: '#4e5e91',
  neutral700: '#384368',
  neutral800: '#3a4569',
  neutral900: '#1f273f',

  blue100: '#f7faff',
  blue200: '#bbd7ff',
  blue300: '#73acfd',
  blue400: '#4b94fc',
  blue500: '#237cfb',
  blue600: '#0856c6',
  blue700: '#063d8c',
  blue800: '#0b2953',
  blue900: '#0f2543',

  red100: '#fff8f7',
  red200: '#ffc3bf',
  red400: '#ff736a',
  red500: '#ff4b40',
  red600: '#c63a31',
  red700: '#8d2923',
  red900: '#411916',

  green100: '#f2fff9',
  green200: '#b8ffdd',
  green500: '#1ae784',
  green600: '#0c9955',
  green900: '#0e3c26',

  yellow100: '#fffcf3',
  yellow200: '#ffeec2',
  yellow500: '#ffcc48',
  yellow600: '#c69e38',
  yellow900: '#362c13',

  pink100: '#fff9fc',
  pink500: '#ff83bf',
  pink900: '#482641',

  purple100: '#fbf8ff',
  purple500: '#9b41f5',
  purple900: '#482641',

  brown100: '#fff6ee',
  brown500: '#db9652',
  brown900: '#342517',
} as const;
